import { render } from "./TargetStream.vue?vue&type=template&id=2b0087a2"
import script from "./TargetStream.vue?vue&type=script&lang=js"
export * from "./TargetStream.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__